module.exports = __webpack_public_path__ + "04_glasses_brown.202b2098.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer4/04_glasses_brown.png
// module id = Fh0N
// module chunks = 0